<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { EmailSnippetReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { ValidationError } from "@common/types";
    import { EmailSenderFormSubmitEventPayload, EmailSenderViewModel } from "@Alternatives/Alternatives/Components/EmailSender";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        },
        watch: {
            opened: 'onOpenedChanged'
        }
    })
    export default class EmailSender extends Vue
    {
        get vm(): EmailSenderViewModel { return this.$props.viewModel as EmailSenderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get sending(): boolean { return this.vm.sending; }
        set sending(val: boolean ) { this.vm.sending = val; }

        get alternativeName(): string { return this.vm.alternativeName; }
        get emailSnippets(): EmailSnippetReadModel[] { return this.vm.emailSnippets; }

        get subjectError(): string | null { return this.vm.errors.find(error => error.ErrorCode.startsWith('Subject.'))?.Error ?? null; }
        get bodyHtmlError(): string | null { return this.vm.errors.find(error => error.ErrorCode.startsWith('Body.'))?.Error ?? null; }
        get replyToEmailError(): string | null { return this.vm.errors.find(error => error.ErrorCode.startsWith('ReplyTo.'))?.Error ?? null; }
        get toEmailsError(): string | null { return this.vm.errors.find(error => error.ErrorCode.startsWith('To.'))?.Error ?? null; }

        subject: string = '';
        bodyHtml: string = '';
        replyToEmail: string = '';
        toEmails: string = '';

        insertEmailSnippet(content: string)
        {
            this.bodyHtml = `${this.bodyHtml} ${content}`.trim();
        }

        //watcher
        onOpenedChanged(val: boolean, oldVal: boolean) 
        {
            if (val)
            {      
                this.vm.clearEmailValidationErrors();

                this.sending = false;
                this.subject = '';
                this.bodyHtml = '';
                this.toEmails = this.vm.defaultTo;
                this.replyToEmail = this.vm.defaultReplyTo;
            }
        }

        handleFormSubmit()
        {
            this.vm.clearEmailValidationErrors();

            this.sending = true;
            const to = this.toEmails.split(/[,;]/).map(email => email.trim());
            this.$emit('form-submit', new EmailSenderFormSubmitEventPayload(this.vm.alternativeId, this.subject, this.replyToEmail, to, this.bodyHtml));
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email: {{alternativeName}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="email-sender-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Send to:</label>
                                <input v-model.trim="toEmails" type="text" class="form-control" required />
                                <div class="error">{{toEmailsError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" v-model.trim="subject" class="form-control" required />
                                <div class="error">{{subjectError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Reply to:</label>
                                <input type="email" v-model.trim="replyToEmail" class="form-control" required />
                                <div class="error">{{replyToEmailError}}</div>
                            </div>

                            <hr />
                            <div class="pull-right">
                                <div class="dropdown">
                                    <a class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                        Insert
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" v-for="s in emailSnippets" :key="s.Title" @click="insertEmailSnippet(s.Content)">
                                            {{s.Title}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <textarea v-model.trim="bodyHtml" class="form-control " rows="5" placeholder="Type your message here..." required />
                            <div class="error">{{bodyHtmlError}}</div>
                        </form>

                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close"  class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="email-sender-form" :disabled="sending"  class="btn btn-primary">Send</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>      
